import FPage from './FPage.vue'

export default FPage
